import React from 'react'
import StyledAnimationWrapper from "components/styled/AnimationWrapper.styled";
import StyledBackgroundWrapper from "components/styled/BackgroundWrapper.styled";
import sexOneAAnimation from "assets/animation/sex-one-a-animation.json";
import Lottie from "lottie-react";

const SvgSexTwoAEnd = () => {
  return (
    <StyledBackgroundWrapper>
      <StyledAnimationWrapper top="22%" left="48%" width="10%">
        <Lottie animationData={sexOneAAnimation} loop={true} autoPlay={true} />
      </StyledAnimationWrapper>
    <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x={0}
    y={0}
    viewBox="0 0 961 1005"
    style={{
      enableBackground: "new 0 0 961 1005",
    }}
    xmlSpace="preserve"
  >
    <style>
      {
        ".st0{fill:none}.st4{fill:#e8a18e}.st6,.st7{opacity:.2;fill:#9e695c;enable-background:new}.st7{fill:#dd8172}.st9{fill:#844339}.st10{fill:#9f5d4a}.st11{opacity:.2;fill:none;stroke:#dd8172;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;enable-background:new}.st12{fill:#1a1a1a}.st14{fill:#121d3b}.st16{fill:#382632}.st17{fill:#fff}"
      }
    </style>
    <pattern
      y={1080}
      width={131}
      height={104}
      patternUnits="userSpaceOnUse"
      id="New_Pattern_Swatch_4"
      viewBox="0 -104 131 104"
      style={{
        overflow: "visible",
      }}
    >
      <path className="st0" d="M0-104h131V0H0z" />
      <path className="st0" d="M0-104h131V0H0z" />
      <path
        style={{
          fill: "#13a89e",
        }}
        d="M0-104h131V0H0z"
      />
    </pattern>
    <path
      d="M819.9 601.6c.5-1-.4 1.3.1.4 15.8-30.9 22.1-69.5 16-103.7C777.1 168.4 956 0 956 0H0v1006c303-300 500.9-238.8 627-272 55.9-14.7 165.6-81.4 192.9-132.4z"
      style={{
        fill: "#02594f",
      }}
      id="Layer_15"
    />
    <g id="Layer_8">
      <pattern
        id="SVGID_1_"
        xlinkHref="#New_Pattern_Swatch_4"
        patternTransform="matrix(1 0 0 -1 1321 -19655)"
      />
      <path
        d="M627 733c55.9-14.7 165.6-81.4 192.9-132.4.5-1-.4 1.3.1.4 15.8-30.9 22.1-69.5 16-103.7C780.2 185 937.6 17.4 954.5.4 934.6 6.6 716.4 82.5 639 450.7c-9.7 46.7-35.9 88.3-73.7 117.3-33.3 25.4-81.9 51.6-151.6 68.6C286 667.8 174 744.5 97.8 851.6c-29.9 41.9-62.3 92.2-96.5 152.1C303.6 705.2 501.1 766.1 627 733z"
        style={{
          fill: "url(#SVGID_1_)",
        }}
      />
    </g>
    <path
      className="st4"
      d="M627 734c55.9-14.7 165.6-81.4 192.9-132.4.5-1-.4 1.3.1.4 9.9-19.8 15.9-41.2 17.7-63.3-15.5-13.6-32.8-28-48.4-38.5 0 0-137.2-4-151.1-.1s-74.3 17.1-98.5 29.9-68.6 53.6-85.7 71.9c-8.6 9.1 3.1 80.1 17.4 151.3 61.1-7.5 112.5-7.9 155.6-19.2z"
      id="Layer_7"
    />
    <g id="People">
      <path
        d="m436.7 453-66.7-.9-.3 21.9c-1.6 5.8-15.2 54-19.4 55.9l47.6 36.7 22 6.4c7.3 1.2 15.5 8.9 14 3l2.8-123z"
        style={{
          fill: "#9b5849",
        }}
      />
      <path
        className="st6"
        d="m434.9 499.2-.5 13.6c-47.9 2.2-64.5-39.4-64.5-39.4 12.4 2.6 65 25.8 65 25.8z"
      />
      <path
        className="st4"
        d="m752.9 503.8-26.2-12.4c-5.1-5.6-7.6-13-7.1-20.5l2.9-47.7-89.5 13.2-2.5 38.8c-.3 4.6.5 35-21.7 45.9 0 0-36.7 13.8-59.7 58-14.4 27.8 105.7-22.8 105.7-22.8s31-7.5 47.7-13.9 30.8-20 30.8-20l15-14.2c1.7-1.4 3.2-2.8 4.6-4.4z"
      />
      <path
        className="st7"
        d="M721.2 450.5c-21.2 17-59.7 35.4-91.8 11.5l1-16 92-19.2-1.2 23.7z"
      />
      <path
        className="st4"
        d="m613 299 85.5-13.8 36.3 76.4-16.1 26.6-50.2 18.7-28.1-8.6-21.1-69.7z"
      />
      <path
        className="st4"
        d="M722.8 416.3s-18.2-1.1-23.1-17.7c-.1-.2-21.4-91.4-53.4-92.1-38-.9-54.3 10.5-58.8 47.6-1.9 15.7-9.5 21.7-17.1 29.3-3 3-.3 8.8 4.3 8.1l5.5-.1c1.2 0 2.3.9 2.4 2.2 1.4 21.1 10.8 50.6 17.4 55.9 4.1 3.3 19.9 8.3 34.7 9.4 56.6 4.1 88.1-42.6 88.1-42.6z"
      />
      <path
        d="M779.8 387.5c4-1.1 5.7-5.1 5.7-9.2 0-4.9-1.5-9.7-4.4-13.6 5.6-7.2 11.8-18.1 2.5-23.5 5.3-2.4 6.5-8.9 5.5-14.9-.5-2.9-7.2-4.9-9.7-5.8 5.5-3.3 10.7-7.6 10.8-14.5.1-2.6-2.3-5.9-1.8-8 .3-1.3 2.1-2.9 2.5-4.5.4-1.5.6-3.1.4-4.7-1-16.3-21.2-21.9-33.8-15 .3-4.8-2.3-9.4-6.7-11.6-4.9-2.6-10.4-1.4-15.2 1 2.8-5.3 1.7-11.8-2.8-15.8-5.9-5.2-14.2-3.9-20.4 0 1.6-7.7-6.6-13.9-13.7-15.4-5.3-1-10.7-.3-15.5 2-2.2 1.1-3.8 2.7-5.8 4-2.8 1.8-2.1 1.2-5.1-.8-4.5-3-9.9-4.2-15.2-3.4-2.5.4-4.9 1.3-7.2 2.6-1.8 1-3.6 3.7-5.4 4.4-2 .8-3.4-2-5.6-3.3-1.8-1-3.7-1.6-5.8-1.8-4.6-.3-8.5 1.8-11.5 5.1-1-2.8-3.1-5.6-6.3-5.7-1.6 0-3.2.5-4.5 1.4-.9.6-1.6 1.5-2.1 2.4-7.2.4-15.3 1.3-20.2 7.2-3.1 3.8-3.5 9 .1 12.1-7 2.5-13.3 7.7-14 15.6-.4 4.4 1.7 9.5 5.6 10.5-4.8 3.3-7.2 9.2-7.1 15.2.2 6.8 5.1 10.5 11.1 8.6-2.2 6 .8 12.7 6.8 14.9 2.5.9 5.2 1 7.7.1 2.3 10.4 19.9 12 27.1 4.9 2.2.2 4.5-.3 6.5-1.4-.8 5.4 2.8 10.4 8.2 11.2 1.7.3 3.4.1 5-.5-2.1 7.4 3 18.4 11.2 16.8-2.1 6.5-1.8 13.3 5 17 1.9 1 10.5 3.9 14.2 3.1.6 3.1 4.2 7.6 5.1 8.9 2.4 3.5 6.1 9.5 6.1 9.5 1.2 3.1 3.3 6 6.4 6.9-2.1 4.2-1 10 4.1 11.5 1.6.5 3.3.4 4.9-.3-1.3 5.4 1.8 12.6 7.3 13.3-7.5 9.9 3.6 27.7 11.3 24.2 2.2 4.3 6.4 7.2 11.2 7.5 5.6.2 8.3-4.2 10.1-6.8 1.4 2.2 6.5 3 8.9 1.8 4.3-2.2 6.5-7 5.2-12.2 6.3 4.8 16.9-6.2 13.2-12.7 8.3-.3 13.2-12.2 7-18 8.5-2.2 8.5-14.8 3.1-20.3z"
        style={{
          fill: "#8f493b",
        }}
      />
      <path
        className="st9"
        d="M584.3 307.5c-.5-3.8-.4-8 2.2-11.1 2-2.5 5.5-3.8 8.5-2.6l-1.2.8c.5-5.1 3.7-9.5 8.4-11.6 4.2-1.7 9.9-.4 10.3 4.8.1 1.1-1.7 1.1-1.8 0-.3-1.9-1.8-3.4-3.7-3.7-2-.2-4 .3-5.6 1.4-3.2 2-5.4 5.4-5.8 9.2 0 .5-.4.9-.9.9h-.2c-2.6-.9-5.5.1-7 2.5-1.8 2.6-1.8 6-1.4 9.1.1 1-1.6 1.5-1.8.3zM645.6 240.3c5.3 2.4 8.6 7.9 8.3 13.7l-1.7-.5c2-2.9 6.2-3 9-1.3 3.3 2 5 5.8 4.5 9.6-.2 1.1-2 1.1-1.8-.1.5-2.9-.7-5.9-3.1-7.7-2-1.5-5.5-2-7.2.4-.3.4-.8.5-1.2.3-.3-.2-.4-.5-.4-.8.3-5-2.5-9.7-7-11.9-.9-.4-.4-2.2.6-1.7zM710.7 423c2.9-.4 5.6-1.7 7.7-3.8 1.1-1 2-2.1 2.8-3.3.7-1.1 2.2-2.9 1.5-4.2l1.7-.6c1.3 4 6.1 4.7 9.5 3 3.5-1.8 5.7-5.5 5.7-9.4.1-.5.5-.8 1-.8.4.1.7.4.8.8 0 5-3.1 9.5-7.8 11.4-4.3 1.6-9.4 0-10.9-4.6-.3-1 1.2-1.5 1.7-.6 1.6 3-2 6.8-3.9 8.8-2.4 2.7-5.7 4.5-9.3 5-1.2.2-1.7-1.6-.5-1.7zM692.6 323.9c-2.5 3.3-1.9 8 1.4 10.5s8 1.9 10.5-1.4c.7-.8 1.6.2 1.5.9-.8 4 1.8 8 5.8 8.8 3.3.7 6.6-1 8.1-4 .6-1 2.1 0 1.5 1-2.4 4.5-8 6.2-12.5 3.8-3.7-1.9-5.6-6.1-4.7-10.1l1.5.9c-3.3 3.9-9.2 4.4-13.1 1.1-3.7-3.1-4.3-8.5-1.5-12.5.7-.9 2.2.1 1.5 1zM757.8 274.5c-3 1.7-5.3 4.5-6.4 7.7-1.1 3.2.5 6.2 2.6 8.6.3.4.3 1-.1 1.3-.2.1-.4.2-.6.2-3.3-.3-6.8 1.3-7.8 4.7-.9 2.8.7 5.8 3.5 6.6.5.1 1 .2 1.5.2.5.1.8.5.8 1-.1.4-.4.7-.8.8-3.9 0-7-3.2-7-7 0-.4 0-.9.1-1.3.8-4.6 5.2-7.2 9.7-6.8-.2.5-.5 1-.7 1.5-2.4-2.7-4.2-6.1-3.2-9.9 1.2-3.9 3.9-7.3 7.5-9.3.5-.2 1 0 1.2.5.2.5.1.9-.3 1.2zM688.6 278.1c.9 4.1 5.5 5.1 9 4.1 3.3-.9 6.1-3.2 7.7-6.3.3-.4.8-.5 1.3-.2l.3.3c3 5.3 9.6 2.1 12.9-.9.9-.8 2.1.5 1.2 1.3-2.3 2.1-5.1 3.9-8.3 4.2-3 .3-5.9-1.2-7.4-3.8l1.5.1c-2 3.9-5.9 6.7-10.3 7.4-4.2.6-8.7-1.4-9.7-5.8-.1-.5.2-1 .7-1.1.4 0 .9.3 1.1.7zM755.6 374.9c-.6-4 .3-8.3 3.7-10.8 2.9-2.1 7.2-1.9 9.5 1.1l-1.4.1c1.1-2.1 3.1-3.6 5.5-3.9 2.8-.3 5.6.5 7.8 2.1.4.3.5.8.3 1.3s-.8.5-1.3.3c-1.9-1.4-4.1-2-6.5-1.9-1.9.2-3.6 1.4-4.4 3.1-.3.4-.8.5-1.3.3-.1 0-.1-.1-.2-.1-1.8-2.2-5.1-2.6-7.3-.7-.1 0-.1.1-.2.1-2.6 2.1-3.2 5.6-2.7 8.7.3 1-1.4 1.4-1.5.3z"
      />
      <path
        className="st4"
        d="M697.4 382.8c-4.5 6.8-11.1 10.4-17.9 6-6.4-4.1-8.6-12.4-5.1-19.1 3.7-7.3 11.9-10.4 18.4-7.2 11.9 5.6 8.9 13.7 4.6 20.3z"
      />
      <path
        className="st7"
        d="M691.8 371.5c0-.5-.4-.8-.8-.9-2.3.1-4.4.9-6.2 2.3-1.9 1.6-3.3 3.7-4.2 6-.4 1 1.2 1.5 1.6.5.6-1.6 1.5-3 2.7-4.3l.3.1c.2.1.4.2.6.4l.1.1.2.2.4.4.1.2c.1.1.1.2.2.4v.1l.1.2V378.1c0 .1-.1.3-.1.4 0 .1-.1.2-.1.3v.1l-.1.2c-.1.1-.1.2-.2.3l-.1.1-.3.3-.3.3c.2-.2 0 0 0 0l-.2.1c-.1.1-.2.1-.4.2l-.2.1c.2-.1 0 0-.1 0-.4.1-.7.6-.6 1 .1.4.6.7 1 .6.8-.2 1.5-.7 2.1-1.2 1-1 1.5-2.5 1.3-3.9-.3-1.3-1.2-2.4-2.3-3.1 1.4-.9 3-1.5 4.7-1.6.4-.1.7-.4.8-.8z"
      />
      <path
        className="st4"
        d="M303.2 621.7c-10.1-3.5-14 10.2-8.7 22.6s6.9 31.2 8.2 37.3-.5 20.7.6 24-4.9 4.2.9 23.8 12.6 26.4 22 31.5S376 772 376 772s-8.4-11.3-8.5-13.2 16 3.3 27.2.9 18.6-8.4 14.3-14.5-21.3-2.6-28-3.3-18.7-3.1-18.7-3.1 15.6-5.5 30.3-11.2 25.6-12 21-20.9-10.7-7.5-20.3-2.4c-27.3 14.5-46.5 15.9-46.5 15.9 6-6.1 13.2-11 21.1-14.3 12.3-4.9 30.9-7.5 34.6-15.1s-4.6-15.5-14.3-12.8-27.2 9.1-37.5 13.3-13.5 7.4-14.8 6.2-.7-9.9 8.3-16.6 20.5-13.4 21.8-19.8-2.7-13.4-14.7-9.2-18 10.5-24.6 16.4l-6.7 5.9c-4.2-8.8-7.8-18-10.7-27.3-4.8-15.8-3.5-24.4-6.1-25.2z"
      />
      <path
        className="st10"
        d="M346.6 530s5.8-2.9 14.4-1c19.8 4.4 60.3 22.6 121 77l-99-3-36.4-73z"
      />
      <path
        className="st11"
        d="M639 557s-4.1-17.4-53.4-10.5M666.6 556s4.1-16 53.4-9.7"
      />
      <path
        className="st10"
        d="M646.9 634.5c34.3-40.7 69.1-86.2 69.3-89.4s-1.1-16.7 4.4-37.3 16-36.7 22.6-42.5 17.7-5.8 17.7-5.8c-.4-2 .1-4 1.4-5.6 2.1-2.7 11-.2 12.4 3.1.8 2.1 1.1 4.5.6 6.7 0 0 4.9-3.7 9.8-1.6s7 10 7 10 9 .9 10.8 7.4 1.3 9.4 1.3 9.4 10.6 4.1 12.2 12.6 2.5 12.5-2.8 18.7-27 28.5-38.8 39.2-17.2 13.2-18.9 15.7-59.4 102.4-59.4 102.4-10.4-14.8-21.6-25.6-28-17.4-28-17.4z"
      />
    </g>
    <g id="eyes">
      <path
        className="st12"
        d="M481.5 417.4c-10.6 1.5-21.1-2.3-20.9-4.7s1.5-4.1 4.3-2.3 18.4 6.7 16.6 7zM472.5 378.3c-1.1-.5-1.6-1.7-1.1-2.8.2-.5.7-1 1.3-1.2 11.7-4 20.3-.5 20.8-.3 1.1.5 1.6 1.7 1.2 2.8-.5 1.1-1.7 1.6-2.8 1.2-.1 0-7.6-3-17.8.4-.6.2-1.1.2-1.6-.1z"
      />
      <path
        d="M511.5 469.3c3.8-6.4 5.8-13.3 8.7-20.1 3.3-7.7 2.7-16.5-1.5-23.8-3.7-6.2-9.9-10.9-12.5-17.6-3.9-10.3 2-22.7-2.9-32.6-19 33.1-32.9 68.8-41.4 106-.9 4.1-1.4 9.2 2.1 11.5l-.4-.8c6.6-1.3 15.2 13.2 21.8 14.5 12.6 2.5 5.6 13.9 20.6 14.1-3.2-7.1-1.6-39.4 5.5-51.2z"
        style={{
          fill: "#0f192d",
        }}
      />
      <path
        className="st10"
        d="M369.1 427.1c1.2-.9 2.5-1.7 3.9-2.4 3.3-1.2-1.3-6.5-1.3-10.1.6-46.3 29.6-85.2 64.7-82.9 41.6 2.7 58.3 16.8 59.6 57.7.5 17.4 8.3 24.7 15.9 33.7 3 3.5-.6 9.7-5.5 8.4l-6-.7c-1.4-.1-2.6.8-2.8 2.2-6 38.3-22.6 66.8-63.2 66.2-51.5-.6-72.4-33.9-80-45.9-.1 0 14.1-15.5 14.7-26.2z"
      />
      <path
        className="st10"
        d="M359.4 409.8c-.1 10.5 7.3 19.1 16.7 19.2s17-8.3 17.2-18.8-7.3-19.1-16.7-19.2-17 8.3-17.2 18.8z"
      />
      <path
        className="st6"
        d="M371 401.6c.2-.5.7-.8 1.2-.7 2.4.9 4.5 2.5 6.1 4.6 1.5 2.4 2.4 5.1 2.6 7.9.1 1.2-1.8 1.2-1.9 0-.1-1.9-.7-3.8-1.5-5.6l-.4.1c-.2.1-.5.1-.7.2l-.2.1-.3.1-.6.3h-.1l-.2.2c-.1.1-.2.2-.3.4v.1l-.1.2c0 .1-.1.1-.1.2v.1c0 .1-.1.3-.1.4V411.6c0 .1.1.3.1.4l.1.2v.1c.1.1.1.3.2.4l.2.4c-.1-.2 0 0 0 0l.1.2.4.4.2.1c-.2-.2 0 0 .1 0 .4.4.4 1 0 1.4-.3.3-.7.4-1 .3-.8-.5-1.4-1.2-1.9-2.1-.8-1.5-.9-3.2-.1-4.7.8-1.3 2.1-2.3 3.6-2.6-1.2-1.5-2.8-2.6-4.6-3.3-.6-.2-.9-.7-.8-1.2z"
      />
      <path
        className="st14"
        d="M516.6 367.4c-.5-12-4.2-24.2-12.6-32.8-4.7-4.8-10.6-8.3-16.5-11.7l-20-11.6c-4.9-2.9-9.9-5.7-15.5-7-6.7-1.5-14.6.2-18.2 6-7-6.8-17.1-9.8-26.8-9.6s-19.2 3.4-28 7.5c-11.5 5.4-22.8 13.4-27.1 25.3-1.9 5.3-2.3 11.1-4.7 16.2-6.7 14-26.7 19-30.4 34-.5 1.9-.6 3.9-.6 5.9-.4 5.8 1.5 11.8 3 17.5.8 3.1 1.3 6.2 1.5 9.4-.1 3.2-1.1 6.4-2.9 9.1-2.2 3.1-5.5 5.2-8.2 7.9 0 0-15.6 24.1 18.1 29.7s15.5-6.2 53.3 11.6c-1.8-2.7.1-6.2.8-8.4 1.6-4.5 4.5-8.6 4.6-13.4v-1.4c0-.3.1-.6.1-.9.2-7.4-6.3-13-11.9-17.9s-10.8-10.2-13.4-17c-.8-2.1-1.2-4.4-1.4-6.6.1-4.3 2-8.3 5.2-11.2 5.5-4.8 13.7-4.5 20.9-5.5 10.2-1.5 20.4-6.8 25.5-15.8 3.6-6.3 4.4-13.8 7.5-20.3 7.3-15.4 28.4-22.2 43.4-14.1 0 0 30.5 17.7 33.3 40.1l.4 6.8 4.1-2.7c1.4 4.1 2.5 8.3 3.2 12.6 9.8-4.9 13.3-17.1 13.2-28.1.2-1.2.2-2.4.1-3.6z"
      />
      <path
        d="M600.1 350.5c-.9-2.9.6-4.1 5-4.5 4.5-.2 8.9.5 13.1 2.2 8.4 3.4 11.7 11.5 9.4 9.9-3.9-2.7-7.2-4.3-16-6.2-4.9-.9-10.9.6-11.5-1.4z"
        style={{
          fill: "#824237",
        }}
      />
      <path
        className="st14"
        d="M482.8 385.5c.8-2.9-1-3.6-6.1-2.9-5.2.9-10.3 2.7-14.9 5.3-9.5 5.2-12.6 13.5-10.1 11.5 4.2-3.5 7.9-5.8 18-9.7 5.4-2.1 12.5-2.2 13.1-4.2z"
      />
      <ellipse className="st16" cx={476.8} cy={410.5} rx={4.4} ry={5} />
      <path
        className="st16"
        d="M607.2 370.3c.3 2.4-1.1 4.6-3.1 4.8s-3.8-1.6-4-4 1.1-4.6 3-4.8 3.8 1.6 4.1 4z"
      />
      <path
        className="st17"
        d="M490.5 449.4c-.4.8-1.2 2.1-1.7 2.8-.2.3-.7 1.1-1 1.6s-.8 1.2-.8 1.2c-13.8-4.4-14.7-12.5-12-11.1 4.9 2.6 10.2 4.4 15.5 5.5zM590.8 409.4c.4.8 1.2 2.1 1.7 2.8.2.3.7 1.1 1 1.6s.8 1.2.8 1.2c13.8-4.4 14.7-12.5 12-11.1-4.9 2.6-10.1 4.4-15.5 5.5z"
      />
    </g>
    <g id="light">
      <path
        className="st10"
        d="M373.8 771.5c106-28.2 188.9-20.6 253.2-37.5 12.2-3.2 26.8-8.8 42.7-16.3 15.5-21.4 28.3-41.2 29.3-44.7 2.3-8-44-48-50.2-40.6-5.2 6.2-55.8 56.6-59.8 54.5s-36.3-24.2-43-29.9c-7-6-40.9-34.8-64-51s-104.4-65.8-128.2-76.2c-7.1-3.1-21.3 6.8-31 18.8-10.8 13.3-28.6 66.7-19.4 88.9 7.6 18.3 52 97.8 70.4 134z"
      />
      <path className="st11" d="m560 642 3.7 27.9" />
    </g>
    <g id="Layer_11">
      <path
        d="M514.7 0H0l1 742S298.4 630 514.7 0z"
        style={{
          fill: "#f2b668",
        }}
      />
      <path
        d="M514.7 0S358.2 496.3 89.1 687.6c0 0-61.1-11.6-90.1-63.6 0 0 231-120 515.7-624z"
        style={{
          fill: "#d89e60",
        }}
      />
    </g>
    <path
      d="M402.5 690.8s9.6 24.6 94.5 58.2"
      style={{
        opacity: 0.2,
        fill: "none",
        stroke: "#9e695c",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        enableBackground: "new",
      }}
      id="Layer_14"
    />
  </svg>
  </StyledBackgroundWrapper>
  )
}

export default SvgSexTwoAEnd